export default "__VITE_ASSET__CW5fI8XR__"